export const SET_SNACK_CONTENT = 'snack/SET_SNACK_CONTENT';
export const SET_SNACK_STATE = 'snack/SET_SNACK_STATE';
export const SET_SNACK = 'snack/SET_SNACK';